module.exports = __webpack_public_path__ + "static/media/icon-16.a1e6d208.png";